import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    this.DOM.video = this.element.querySelector("video");
    this.DOM.controls = this.element.querySelector('[g-ref="controls"]');
    this.DOM.soundOn = this.element.querySelector('[g-ref="soundOn"]');
    this.DOM.soundOff = this.element.querySelector('[g-ref="soundOff"]');
    this.DOM.play = this.element.querySelector('[g-ref="play"]');
    this.DOM.pause = this.element.querySelector('[g-ref="pause"]');

    this.DOM.soundOff.classList.add("tw-hidden");
    this.DOM.pause.classList.add("tw-hidden");

    this.DOM.video.addEventListener("click", () => {
      this.DOM.video.paused ? this.playVideo() : this.pauseVideo();
    });

    this.DOM.soundOn.addEventListener("click", () => {
      this.muteVideo();
    });

    this.DOM.soundOff.addEventListener("click", () => {
      this.unmuteVideo();
    });

    this.DOM.play.addEventListener("click", () => {
      this.playVideo();
    });

    this.DOM.pause.addEventListener("click", () => {
      this.pauseVideo();
    });

    this.st = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: "top center",
      end: "bottom center",
      markers: false,
      onEnter: () => {
        this.playVideo();
      },
      onEnterBack: () => {
        this.playVideo();
      },
      onLeave: () => {
        this.pauseVideo();
      },
      onLeaveBack: () => {
        this.pauseVideo();
      },
    });
  }

  playVideo() {
    this.DOM.video.play();
    this.DOM.play.classList.add("tw-hidden");
    this.DOM.pause.classList.remove("tw-hidden");
  }

  pauseVideo() {
    this.DOM.video.pause();
    this.DOM.play.classList.remove("tw-hidden");
    this.DOM.pause.classList.add("tw-hidden");
  }

  muteVideo() {
    this.DOM.video.muted = true;
    this.DOM.soundOn.classList.add("tw-hidden");
    this.DOM.soundOff.classList.remove("tw-hidden");
  }

  unmuteVideo() {
    this.DOM.video.muted = false;
    this.DOM.soundOn.classList.remove("tw-hidden");
    this.DOM.soundOff.classList.add("tw-hidden");
  }

  unmount() {
    this.st?.kill();
  }
}
